import axios from 'axios'
import Qs from 'qs'
import Router from '@/router'
import store from '@/store'
class Http {
  config() {
    // 基础配置
    const config = {
      timeout: 10000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    return config
  }

  interceptors(instance) {
    // 请求拦截
    instance.interceptors.request.use(
      request => {
        // 配置请求参数
        let requestData = request.parameters || {}
        if (request.headers['Content-Type'] === 'multipart/form-data') {
          requestData = requestData.formData
        }
        if (request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
          requestData = Qs.stringify(requestData, {
            allowDots: true,
            arrayFormat: 'repeat'
          })
          if (request.method === 'get') {
            request.url = `${request.url}${requestData ? `?${requestData}` : ''}`
          } else request.data = requestData
        } else {
          if (request.method === 'get') request.params = requestData
          else request.data = requestData
        }
        return request
      },
      error => {
        return Promise.reject(error)
      }
    )
    // 响应拦截
    instance.interceptors.response.use(
      res => {
        // 登录已失效则退出
        const BASE_URL = process.env.BASE_URL.replace(/\//g, '')
        if (BASE_URL === 'sevapp' && [2301].indexOf(res.data.code) > -1 && store.state.sev.sid) {
          store.commit('RESET')
          Router.push(`/404?text=${res.data.msg}`)
        }
        return res.data
      },
      error => {
        return Promise.reject(error)
      }
    )
  }

  request(options) {
    // 实例化
    const instance = axios.create()
    // 合并配置
    const config = this.config()
    const headers = Object.assign({}, config.headers, options.headers)
    options = Object.assign(config, options)
    options.headers = headers

    // token验证
    if (options.app) {
      const BASE_URL = process.env.BASE_URL.replace(/\//g, '')
      let token = Router.currentRoute.query.token || store.state.sev.appToken
      if (['sev'].includes(options.app)) token = store.state.sev.sid
      if (!token) {
        if (process.env.NODE_ENV === 'development') {
          const tokenList = {
            scapp: 1101110323, // 32
            // scapp: 1101110074, // 141
            lblapp: 'a4ec9c3531724263b5132a8541266d8f', // 66
            sevapp: '8969e30d48704758bd088022361e2320'
          }
          token = tokenList[BASE_URL]
        } else Router.push('/404?text=未识别的用户身份')
      }

      if (['lbl', 'cloud'].includes(options.app)) {
        headers.Authorization = `Bearer ${token}`
      }

      if (['sc'].includes(options.app)) {
        headers.companyNo = token
      }

      if (['sev'].includes(options.app)) {
        headers.sid = token // 请求智慧生活不需要传入sid
      }
    }

    // 拦截器
    this.interceptors(instance)
    return instance(options)
  }
}

export default Http
